// Module
var code = "\n<div class=\"iframe-popup-trigger\"><a class=\"{{ form.fieldHtmlClass }}\" magnific-popup=\"{type: &quot;iframe&quot;}\" ng-href=\"{{ evalExpr(form.url) }}\">{{ form.title }}</a></div>";
// Exports
export default code;